/** Returns a new object with properties matching 'keys' stripped (like `lodash/omit`) */
export default function omit(object = {}, keys = []) {
  return Object.entries(object).reduce(
    (accum, [key, value]) =>
      keys.includes(key) ? accum : { ...accum, [key]: value },
    {}
  );
}
